import { getTotalDistance } from "./getTotalDistance";

const calculateSpeedsAndPaces = (points, activity = "hike") => {
  // Activity-based filter settings
  const settings = {
    hike: { window: 5, maxSpeed: 18, minDistance: 5 }, // less strict for Garmin-like results
    run: { window: 10, maxSpeed: 20, minDistance: 15 }, // moderate
    bike: { window: 5, maxSpeed: 50, minDistance: 20 }, // faster, shorter smoothing
  };

  // Fallback to "run" settings if activity type is unknown
  const {
    window,
    maxSpeed: cutoff,
    minDistance,
  } = settings[activity] || settings.run;

  let maxSpeed = 0;
  let minPace = Infinity;

  for (let i = 1; i < points.length; i++) {
    let j = i - 1;
    let timeWindow = 0;
    let distWindow = 0;

    // Look back until the time window is reached
    while (j >= 0 && timeWindow < window) {
      const timeDiff =
        (new Date(points[j + 1].time) - new Date(points[j].time)) / 1000;
      if (timeDiff <= 0) break;
      timeWindow += timeDiff;
      distWindow += getTotalDistance([points[j], points[j + 1]]);
      j--;
    }

    // Skip if there isn't enough time or distance
    if (timeWindow < 3) continue;
    if (distWindow < minDistance) continue;

    const speed = (distWindow / timeWindow) * 3.6; // km/h

    // Skip unrealistic spikes based on activity type
    if (speed > cutoff) continue;

    const pace = speed > 0 ? 60 / speed : Infinity;

    // Track the highest speed and fastest pace (lowest pace value)
    if (speed > maxSpeed) maxSpeed = speed;
    if (pace < minPace) minPace = pace;
  }

  return {
    maxSpeed: parseFloat(maxSpeed.toFixed(1)), // km/h
    maxPace: isFinite(minPace) ? parseFloat(minPace.toFixed(2)) : 0, // min/km
  };
};

const getSpeedStatistics = (points, totalDist) => {
  const totalTime =
    (new Date(points[points.length - 1].time) - new Date(points[0].time)) /
    1000;

  const average = totalTime > 0 ? (totalDist / totalTime) * 3.6 : 0;

  return { average: parseFloat(average.toFixed(1)) };
};

const getPaceStatistics = (points, totalDist) => {
  const totalTime =
    (new Date(points[points.length - 1].time) - new Date(points[0].time)) /
    1000;

  const average = totalTime > 0 ? totalTime / 60 / (totalDist / 1000) : 0;

  return { average: parseFloat(average.toFixed(2)) };
};

export const getTempoStatistics = (points = null) => {
  if (!points || points.length < 2) return null;

  const totalDist = getTotalDistance(points);

  const speedStats = getSpeedStatistics(points, totalDist);
  const paceStats = getPaceStatistics(points, totalDist);
  const { maxSpeed, maxPace } = calculateSpeedsAndPaces(points);

  return {
    speed: {
      ...speedStats,
      peak: maxSpeed,
    },
    pace: { ...paceStats, peak: maxPace },
  };
};
